(function () {
  var MOBILE_MEDIA = '(max-width: 699px)';

  function clamp(value, min, max) {
    return Math.min(Math.max(value, min), max);
  }

  function escapeHtml(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function formatDate(isoString, locale) {
    if (!isoString) return '';

    try {
      return new Intl.DateTimeFormat(locale || 'de-DE', {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
      }).format(new Date(isoString));
    } catch (_error) {
      return '';
    }
  }

  function renderStars(rating) {
    var value = Math.round(Number(rating) || 0);
    var stars = '';

    for (var index = 1; index <= 5; index += 1) {
      stars += '<span class="product-review-carousel__star' + (index <= value ? ' is-filled' : '') + '" aria-hidden="true">★</span>';
    }

    return '<div class="product-review-carousel__stars" aria-label="' + escapeHtml(value + ' out of 5 stars') + '">' + stars + '</div>';
  }

  function resolveProductUrl(url, shopOrigin) {
    var value = String(url || '').trim();

    if (!value) return '';

    if (/^https?:\/\//i.test(value)) return value;

    if (value.startsWith('//')) return 'https:' + value;

    if (value.startsWith('/')) return value;

    if (shopOrigin) {
      return String(shopOrigin).replace(/\/$/, '') + '/' + value.replace(/^\//, '');
    }

    return '/' + value.replace(/^\//, '');
  }

  function buildProductHtml(review, overrides, config) {
    var product = review.product || {};
    var name = overrides.name || product.name || '';
    var urlSource = overrides.url || (overrides.handle ? '/products/' + overrides.handle : '') || product.url || '';
    var url = resolveProductUrl(urlSource, config.shopOrigin);
    var imageUrl = overrides.imageUrl || product.imageUrl || '';
    var showProductImage = config.showProductImage;
    var showProductLink = config.showProductLink;
    var productLinkLabel = config.productLinkLabel || 'Zum Produkt';

    if (!name && !imageUrl) return '';

    var html = '<div class="product-review-carousel__product">';

    if (showProductImage && imageUrl) {
      if (showProductLink && url) {
        html += '<a class="product-review-carousel__product-media" href="' + escapeHtml(url) + '">';
      } else {
        html += '<div class="product-review-carousel__product-media">';
      }

      html += '<img class="product-review-carousel__product-image" src="' + escapeHtml(imageUrl) + '" alt="' + escapeHtml(name) + '" loading="lazy" width="72" height="72">';

      if (showProductLink && url) {
        html += '</a>';
      } else {
        html += '</div>';
      }
    }

    html += '<div class="product-review-carousel__product-meta">';

    if (name) {
      if (showProductLink && url) {
        html += '<a class="product-review-carousel__product-name" href="' + escapeHtml(url) + '">' + escapeHtml(name) + '</a>';
      } else {
        html += '<p class="product-review-carousel__product-name">' + escapeHtml(name) + '</p>';
      }
    }

    if (showProductLink && url) {
      html += '<a class="product-review-carousel__product-link" href="' + escapeHtml(url) + '">' + escapeHtml(productLinkLabel) + '</a>';
    }

    html += '</div></div>';

    return html;
  }

  function buildSectionBadge(config) {
    if (!config.showTrustedShopsBadge || !config.trustedShopsBadgeImageUrl) return '';

    return [
      '<div class="product-review-carousel__section-badge" aria-hidden="true">',
      '<img class="product-review-carousel__section-badge-image" src="' + escapeHtml(config.trustedShopsBadgeImageUrl) + '" alt="" loading="lazy" decoding="async" width="40" height="40">',
      '</div>',
    ].join('');
  }

  function buildReviewCard(review, overrides, config) {
    var reviewer = (review.customer && review.customer.fullName) || '';
    var dateLabel = formatDate(review.submittedAt, config.locale);

    return [
      '<article class="product-review-carousel__card">',
      renderStars(review.rating),
      review.title ? '<h3 class="product-review-carousel__title">' + escapeHtml(review.title) + '</h3>' : '',
      review.comment ? '<p class="product-review-carousel__comment">' + escapeHtml(review.comment) + '</p>' : '',
      !review.comment && !review.title && review.rating
        ? '<p class="product-review-carousel__comment product-review-carousel__comment--statement">' + escapeHtml(config.statementFallback || 'Verifizierte Produktbewertung') + '</p>'
        : '',
      '<div class="product-review-carousel__meta">',
      reviewer ? '<span class="product-review-carousel__reviewer">' + escapeHtml(reviewer) + '</span>' : '',
      dateLabel ? '<time class="product-review-carousel__date" datetime="' + escapeHtml(review.submittedAt || '') + '">' + escapeHtml(dateLabel) + '</time>' : '',
      '</div>',
      buildProductHtml(review, overrides, config),
      buildSectionBadge(config),
      '</article>',
    ].join('');
  }

  function syncTrackHeight(carousel) {
    if (!carousel.track || !carousel.slides.length) return;

    var viewport = carousel.querySelector('.product-review-carousel__viewport');
    var isMobile = window.matchMedia(MOBILE_MEDIA).matches;

    carousel.track.style.height = '';
    carousel.track.style.minHeight = '';

    if (!viewport) return;

    if (!isMobile) {
      viewport.style.minHeight = '';
      return;
    }

    var selectedSlide = carousel.slides[carousel.currentIndex];

    if (!selectedSlide) return;

    var card = selectedSlide.querySelector('.product-review-carousel__card');
    var cardShell = selectedSlide.querySelector('[data-product-review-card]');
    var measured = card || cardShell || selectedSlide;
    var trackStyles = window.getComputedStyle(carousel.track);
    var trackPadding =
      (parseFloat(trackStyles.paddingTop) || 0) + (parseFloat(trackStyles.paddingBottom) || 0);
    var height = Math.ceil(measured.getBoundingClientRect().height + trackPadding);

    viewport.style.minHeight = height + 'px';
  }

  var ProductReviewCarousel = class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;

      this.initialized = true;
      this.track = this.querySelector('[data-product-review-track]');
      this.slides = Array.from(this.querySelectorAll('[data-product-review-slide]'));
      this.previousButton = this.querySelector('[data-product-review-prev]');
      this.nextButton = this.querySelector('[data-product-review-next]');
      this.dots = Array.from(this.querySelectorAll('[data-product-review-dot]'));
      this.currentIndex = 0;
      this.dragStartX = 0;
      this.dragDeltaX = 0;
      this.isDragging = false;
      this.currentTranslate = 0;
      this.resizeRaf = null;
      this.reviewsLoaded = false;

      if (!this.track || this.slides.length === 0) return;

      this.bindEvents();
      this.observeSlideResize();
      this.update(false);
      this.observeForLazyLoad();
    }

    getConfig() {
      var configNode = this.querySelector('[data-product-review-config]');

      if (!configNode) return {};

      try {
        return JSON.parse(configNode.textContent || '{}');
      } catch (_error) {
        return {};
      }
    }

    observeSlideResize() {
      if (!('ResizeObserver' in window)) return;

      this.resizeObserver = new ResizeObserver(() => this.onResize());
      this.slides.forEach((slide) => this.resizeObserver.observe(slide));
      this.observeRenderedCards();
    }

    observeRenderedCards() {
      if (!this.resizeObserver) return;

      this.slides.forEach((slide) => {
        var card = slide.querySelector('.product-review-carousel__card, [data-product-review-card]');

        if (card) {
          this.resizeObserver.observe(card);
        }
      });
    }

    bindEvents() {
      if (this.previousButton) {
        this.previousButton.addEventListener('click', () => this.goTo(this.currentIndex - 1));
      }

      if (this.nextButton) {
        this.nextButton.addEventListener('click', () => this.goTo(this.currentIndex + 1));
      }

      this.dots.forEach((dot, index) => {
        dot.addEventListener('click', () => this.goTo(index));
      });

      this.track.addEventListener('pointerdown', (event) => this.onPointerDown(event));
      this.track.addEventListener('pointermove', (event) => this.onPointerMove(event));
      this.track.addEventListener('pointerup', () => this.onPointerUp());
      this.track.addEventListener('pointercancel', () => this.onPointerUp());
      this.track.addEventListener('lostpointercapture', () => this.onPointerUp());

      this.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowLeft') this.goTo(this.currentIndex - 1);
        if (event.key === 'ArrowRight') this.goTo(this.currentIndex + 1);
      });

      window.addEventListener('resize', () => this.onResize(), { passive: true });
    }

    observeForLazyLoad() {
      if (!('IntersectionObserver' in window)) {
        this.loadReviews();
        return;
      }

      var observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;

          observer.disconnect();
          this.loadReviews();
        });
      }, { rootMargin: '250px 0px' });

      observer.observe(this);
    }

    collectSlideRequests() {
      return this.slides
        .map((slide) => {
          var target = slide.querySelector('[data-product-review-card]');
          var slideKey = (target && target.getAttribute('data-slide-key')) || '';
          var productSkus = (target && target.getAttribute('data-product-skus')) || '';
          var reviewId = (target && target.getAttribute('data-review-id')) || '';

          return {
            slide: slide,
            target: target,
            slideKey: slideKey.trim(),
            productSkus: productSkus.trim(),
            reviewId: reviewId.trim(),
            overrides: {
              name: target ? target.getAttribute('data-product-name-override') || '' : '',
              url: target ? target.getAttribute('data-product-url-override') || '' : '',
              handle: target ? target.getAttribute('data-product-handle-override') || '' : '',
              imageUrl: target ? target.getAttribute('data-product-image-override') || '' : '',
            },
          };
        })
        .filter((item) => item.target && item.slideKey && (item.productSkus || item.reviewId));
    }

    buildProxyUrl(config, requests) {
      var proxyUrl = (config.proxyUrl || '').replace(/\/$/, '');

      if (!proxyUrl) return '';

      var url = new URL(proxyUrl);
      var items = requests.map((item) => ({
        key: item.slideKey,
        sku: item.productSkus,
        reviewId: item.reviewId || '',
      }));

      url.searchParams.set('items', JSON.stringify(items));

      if (config.shopOrigin) {
        url.searchParams.set('shop', config.shopOrigin);
      }

      return url.toString();
    }

    loadReviews() {
      if (this.reviewsLoaded) return;

      this.reviewsLoaded = true;

      var config = this.getConfig();
      var requests = this.collectSlideRequests();

      if (!requests.length) return;

      var missingSkuRequests = requests.filter((item) => !item.productSkus && !item.reviewId);

      if (missingSkuRequests.length === requests.length) {
        missingSkuRequests.forEach((item) => {
          item.target.innerHTML = '<p class="product-review-carousel__error">' + escapeHtml(config.missingReviewMessage || 'Review could not be loaded.') + '</p>';
          item.target.removeAttribute('aria-busy');
        });
        syncTrackHeight(this);
        this.update(false);
        return;
      }

      var endpoint = this.buildProxyUrl(config, requests.filter((item) => item.productSkus || item.reviewId));

      if (!endpoint) {
        requests.forEach((item) => {
          item.target.innerHTML = '<p class="product-review-carousel__error">' + escapeHtml(config.missingProxyMessage || 'Reviews proxy URL is not configured.') + '</p>';
          item.target.removeAttribute('aria-busy');
        });
        syncTrackHeight(this);
        this.update(false);
        return;
      }

      fetch(endpoint, {
        method: 'GET',
        headers: { Accept: 'application/json' },
        credentials: 'omit',
      })
        .then((response) => {
          if (!response.ok) {
            throw new Error('Proxy request failed (' + response.status + ')');
          }

          return response.json();
        })
        .then((payload) => {
          var reviewsByKey = Object.create(null);
          var errorsByKey = Object.create(null);

          (payload.reviews || []).forEach((review) => {
            if (review && review.key) {
              reviewsByKey[review.key] = review;
            }
          });

          (payload.errors || []).forEach((error) => {
            if (error && error.key) {
              errorsByKey[error.key] = error.message || config.missingReviewMessage || 'Review could not be loaded.';
            }
          });

          requests.forEach((item) => {
            if (!item.productSkus && !item.reviewId) {
              item.target.innerHTML = '<p class="product-review-carousel__error">' + escapeHtml(config.missingReviewMessage || 'Review could not be loaded.') + '</p>';
              item.target.removeAttribute('aria-busy');
              return;
            }

            var review = reviewsByKey[item.slideKey];

            if (!review) {
              var errorMessage = errorsByKey[item.slideKey] || config.missingReviewMessage || 'Review could not be loaded.';
              item.target.innerHTML = '<p class="product-review-carousel__error">' + escapeHtml(errorMessage) + '</p>';
              item.target.removeAttribute('aria-busy');
              return;
            }

            item.target.innerHTML = buildReviewCard(review, item.overrides, config);
            item.target.removeAttribute('aria-busy');
          });

          this.observeRenderedCards();
          syncTrackHeight(this);
          this.onResize(false);
        })
        .catch((error) => {
          console.warn('[eTrusted product review carousel]', error, endpoint);

          requests.forEach((item) => {
            item.target.innerHTML = '<p class="product-review-carousel__error">' + escapeHtml(config.loadErrorMessage || 'Reviews are temporarily unavailable.') + '</p>';
            item.target.removeAttribute('aria-busy');
          });

          this.observeRenderedCards();
          syncTrackHeight(this);
          this.onResize(false);
        });
    }

    onPointerDown(event) {
      if (event.button !== undefined && event.button !== 0) return;

      if (event.target.closest('a, button, input, textarea, select, label')) return;

      this.isDragging = true;
      this.dragStartX = event.clientX;
      this.dragDeltaX = 0;
      this.track.classList.add('is-dragging');
      this.track.setPointerCapture(event.pointerId);
    }

    onPointerMove(event) {
      if (!this.isDragging) return;

      this.dragDeltaX = event.clientX - this.dragStartX;
      this.track.style.transform = 'translateX(' + (this.currentTranslate + this.dragDeltaX) + 'px)';
    }

    onPointerUp() {
      if (!this.isDragging) return;

      var threshold = Math.min(90, this.track.clientWidth * 0.18);

      this.track.classList.remove('is-dragging');
      this.isDragging = false;

      if (Math.abs(this.dragDeltaX) > threshold) {
        this.goTo(this.currentIndex + (this.dragDeltaX < 0 ? 1 : -1));
      } else {
        this.update();
      }
    }

    goTo(index) {
      this.currentIndex = clamp(index, 0, this.slides.length - 1);
      this.update();
    }

    update(animate) {
      this.track.style.transition = animate === false ? 'none' : '';
      this.currentTranslate = this.getTranslateForIndex(this.currentIndex);
      this.track.style.transform = 'translateX(' + this.currentTranslate + 'px)';

      this.slides.forEach((slide, index) => {
        var isCurrent = index === this.currentIndex;
        slide.toggleAttribute('aria-hidden', !isCurrent);
        slide.classList.toggle('is-selected', isCurrent);
        slide.classList.toggle('is-before', index === this.currentIndex - 1);
        slide.classList.toggle('is-after', index === this.currentIndex + 1);
      });

      this.dots.forEach((dot, index) => {
        var isCurrent = index === this.currentIndex;
        dot.classList.toggle('is-selected', isCurrent);
        dot.setAttribute('aria-current', isCurrent ? 'true' : 'false');
      });

      if (this.previousButton) this.previousButton.disabled = this.currentIndex === 0;
      if (this.nextButton) this.nextButton.disabled = this.currentIndex === this.slides.length - 1;

      if (animate === false) {
        requestAnimationFrame(() => {
          this.track.style.transition = '';
        });
      }

      syncTrackHeight(this);
    }

    getTranslateForIndex(index) {
      var slide = this.slides[index];
      var viewport = this.querySelector('.product-review-carousel__viewport');

      if (!slide || !viewport) return 0;

      var viewportCenter = viewport.clientWidth / 2;
      var slideCenter = slide.offsetLeft + slide.offsetWidth / 2;

      return viewportCenter - slideCenter;
    }

    onResize(shouldUpdate) {
      if (this.resizeRaf) return;

      this.resizeRaf = requestAnimationFrame(() => {
        this.resizeRaf = null;
        syncTrackHeight(this);

        if (shouldUpdate !== false) {
          this.update(false);
        }
      });
    }
  };

  if (!window.customElements.get('product-review-carousel')) {
    window.customElements.define('product-review-carousel', ProductReviewCarousel);
  }
}());
